module.exports = __webpack_public_path__ + "img/cloud-slash-fill.6aac901f.svg";